import { _SvLicenciaObtenerConfiguracionOrganizacion } from '../../data/licencias/LicenciaApi';
import { DataUtil } from '../../data/util/Util';
import { DateV2 } from '../../util/DateV2';
import { _APP_CONFIG } from '../config/AppConfig';
import { CLicenciaModuloExtra, ILicenciaConfigOrganizacion, ILicenciaConfigOrganizacionDetalleAdeudo } from '../types/LicenciaTypes';

class LicenseService {
    private static instance: LicenseService;

    private currentLicense: ILicenciaConfigOrganizacion | null = null;

    private constructor() { }

    public static getInstance(): LicenseService {
        if (!LicenseService.instance) {
            LicenseService.instance = new LicenseService();
        }
        return LicenseService.instance;
    }

    // ============================================
    // #region API
    // ============================================

    public _GetLicense(): ILicenciaConfigOrganizacion | null {
        return this.currentLicense;
    }

    public _GetAdeudos(): ILicenciaConfigOrganizacionDetalleAdeudo[] {
        return this.currentLicense?.DetalleAdeudos || [];
    }

    public _GetAdeudosExpirados(): ILicenciaConfigOrganizacionDetalleAdeudo[] {
        return this._GetAdeudos().filter(d => this.evalFechaTolerancia(d));
    }

    public _HasAdeudosExpirados(): boolean {
        return this._GetAdeudos().some(d => this.evalFechaTolerancia(d));
    }

    public _IsEscuelaExpirada(idEscuela: number): boolean {
        const adeudosEscuela = this._GetAdeudos().filter(d => d.IdEscuela === idEscuela);
        if (!adeudosEscuela.length) return false;

        return adeudosEscuela.some(d => this.evalFechaTolerancia(d));
    }

    public _EvalDetalleAdeudoExpirado(detalle: ILicenciaConfigOrganizacionDetalleAdeudo): boolean {
        return this.evalFechaTolerancia(detalle);
    }

    public _HasModuloExtra(modulo: CLicenciaModuloExtra): boolean {
        return this.currentLicense?.ModulosExtra.includes(modulo) || false;
    }

    public async _LoadConfig(): Promise<ILicenciaConfigOrganizacion | null> {
        const idOrganizacion = DataUtil._Usuario?.IdOrganizacion;

        if (!idOrganizacion) {
            console.warn("No hay ID de organización para cargar la licencia");
            return null;
        }

        if (_APP_CONFIG.RELEASE_MODE || _APP_CONFIG.BETA_MODE) {
            // Asigna una licencia FALSA para evitar bloqueos en modos (production y beta), desde:
            // PROD - 11/11/2024 - Reyno
            // BETA - 22/11/2024 - Reyno
            this.currentLicense = {
                IdConfig: -1,
                ModulosExtra: [CLicenciaModuloExtra.Finanzas],
            } as ILicenciaConfigOrganizacion;
            return this.currentLicense;
        }

        return _SvLicenciaObtenerConfiguracionOrganizacion(idOrganizacion).then(res => {
            if (res.Datos) {
                this.currentLicense = res.Datos;
                this.formatFechas(this.currentLicense.DetalleAdeudos);
            }
            return this.currentLicense;
        });

    }

    // ============================================
    // #region UTILIDADES
    // ============================================

    /** Evalúa si la fecha de tolerancia de un adeudo ha expirado */
    private evalFechaTolerancia(d: ILicenciaConfigOrganizacionDetalleAdeudo): boolean {
        const dtTolerancia = new Date(d.FechaTolerancia);
        const today = new DateV2()._Truncate("Hour");
        return today > dtTolerancia;
    }

    // Limpieza de datos recibidos del servidor
    private formatFechas(adeudos?: ILicenciaConfigOrganizacionDetalleAdeudo[]) {
        if (!adeudos) return;
        for (const det of adeudos) {
            det.FechaAplicacion += 'T00:00';
            det.FechaTolerancia += 'T00:00';
            det.FechaInicio += 'T00:00';
            det.FechaFin += 'T00:00';
        }
    }
}

export const licenseService = LicenseService.getInstance();